/**
 * Cycles landing page constants (NXTGEN-5678).
 */

import { CHECKLIST_FROM, LOCATION_SELECT_ALL } from '../../../utils/constants.js';

export {
  createInitialCyclesFilter,
  DEFAULT_CYCLES_FILTERS,
} from '../../../utils/cyclesFilterConstants.js';

export { CHECKLIST_FROM, LOCATION_SELECT_ALL };

export const CYCLE_STATUS_TABS = [
  { key: 'all', label: 'All' },
  { key: 'open', label: 'Open' },
  { key: 'closed', label: 'Closed' },
];

export const TABLE_HEADERS = [
  { text: 'Name', value: 'description', sortable: false, filterable: false, visible: true },
  { text: 'Period', value: 'period', sortable: false, filterable: false, visible: true },
  { text: 'Location', value: 'location', sortable: false, filterable: false, visible: true },
  { text: 'Status', value: 'status', sortable: false, filterable: false, visible: true },
  { text: 'UPSI', value: 'upsi', sortable: false, filterable: false, visible: true },
  { text: 'Progress', value: 'progress', sortable: false, filterable: false, visible: true },
  { text: '', value: 'action', sortable: false, filterable: false, visible: true },
];

/** UI labels for template picker (plan §7.2 / Figma Add Cycle). */
export const TEMPLATE_OPTIONS = [
  {
    _id: CHECKLIST_FROM.CHECKLIST_MASTER,
    label: 'Monthly Close - Standard',
    checklistfrom: CHECKLIST_FROM.CHECKLIST_MASTER,
  },
  {
    _id: CHECKLIST_FROM.BLANK,
    label: 'Blank',
    checklistfrom: CHECKLIST_FROM.BLANK,
  },
  {
    _id: CHECKLIST_FROM.PREVIOUS_PROJECT,
    label: 'Copy from previous cycle',
    checklistfrom: CHECKLIST_FROM.PREVIOUS_PROJECT,
  },
];

/**
 * Populate Checklist / Template dropdown items — Figma Add Cycle labels.
 */
export const POPULATE_CHECKLIST_ITEMS = TEMPLATE_OPTIONS.map((opt) => ({
  _id: opt._id,
  name: opt.label,
  checklistfrom: opt.checklistfrom,
}));

/** API field → Add/Edit Cycle form label (used in validation toasts and field errors). */
export const CYCLE_FORM_FIELD_LABELS = {
  description: 'Cycle Name',
  from: 'Period',
  to: 'Period',
  cycle_type: 'Type',
  cycleType: 'Type',
  location: 'Location',
  checklistfrom: 'Template',
  project: 'Select Project',
  previousCycleId: 'Select Project',
  tags: 'Frequency',
};

export const CYCLE_TYPE_OPTIONS = [
  { name: 'FBC', displayText: 'FBC', legend: 'Financial Books Close' },
  { name: 'RM', displayText: 'RM', legend: 'Risk Management' },
  { name: 'IA', displayText: 'IA', legend: 'Internal Audit' },
];

export {
  MONTH_SHORT_NAMES,
  MONTH_FULL_NAMES,
} from '../../../utils/periodConstants.js';

export const ITEMS_PER_PAGE = 20;

/** Poll interval while a cycle is still being created (pending / in progress). */
export const POLL_INTERVAL_MS = 45000;
